import React from "react";

const FileInput = (props) => {
  const {
    label,
    name,
    id,
    accept,
    value,
    onChange = () => {},
    onBlur = () => {},
    hasError = false,
    errorMessage = "error",
  } = props;

  return (
    <span className="flex flex-col gap-y-1 w-full">
      <label className="text-white capitalize">{label}</label>

      <div className="relative">
        <input
          type="file"
          className="bg-[#333] px-2 py-3 rounded-sm text-white w-full file:mr-4 file:py-2 file:px-4 file:rounded-sm file:border-0 file:text-sm file:font-semibold file:bg-[#555] file:text-white hover:file:bg-[#666] cursor-pointer"
          onChange={onChange}
          name={name}
          id={id}
          accept={accept}
          onBlur={onBlur}
        />
      </div>

      <p className={`text-xs text-red ${hasError ? "opacity-1" : "opacity-0"}`}>
        {errorMessage}
      </p>
    </span>
  );
};

export default FileInput;
